import palette from '@utils/theme/palette';
import CustomIcon from '@components/utils/CustomIcon';
import { ShareIcon } from '@assets/icons';
import Tooltip from '@components/ui/Tooltip/next';
import Typography from '@components/Typography';

import { ColCustomIcon, FavoritesContainer, IconsContainer } from './style';
import { SOCIAL_LINKS } from './utils';
import { SocialItem } from './SocialItem';
type Props = {
  link: string;
  itemId?: number;
  itemName?: string;
  hotelListing?: boolean;
  listName?: string;
  isFavoritesShare?: boolean;
};
const renderSocials = ({
  link,
  itemId,
  itemName,
  hotelListing,
  isFavoritesShare,
  listName,
}: Props) => {
  return (
    <IconsContainer>
      {SOCIAL_LINKS.map((item) => {
        return (
          <SocialItem
            listName={listName}
            isFavoritesShare={isFavoritesShare}
            hotelListing={hotelListing}
            itemId={itemId}
            itemName={itemName}
            link={link}
            item={item}
            key={item.name}
          />
        );
      })}
    </IconsContainer>
  );
};

export const SocialShare = ({
  link,
  iconSize,
  isFavoritesShare = false,
  itemId,
  itemName,
  hotelListing,
  listName,
}: {
  link: string;
  iconSize?: number;
  isFavoritesShare?: boolean;
  itemId?: number;
  itemName?: string;
  hotelListing?: boolean;
  listName?: string;
}) => {
  return isFavoritesShare ? (
    <Tooltip
      overlayInnerStyle={{
        height: '185px',
        width: '200px',
        borderRadius: '8px',
        backgroundColor: palette.white,
        padding: '12px 16px',
        marginTop: '5px',
      }}
      arrowColor={palette.white}
      placement='bottomRight'
      trigger='click'
      title={renderSocials({
        link,
        itemId,
        itemName,
        listName,
        isFavoritesShare,
      })}
      getPopupContainer={(node) => node}
    >
      <FavoritesContainer>
        <Typography variant='caption2' weight='Regular' color='D400'>
          Paylaş
        </Typography>
        <CustomIcon fontSize={20} paletteColor='D400' icon={ShareIcon} />
      </FavoritesContainer>
    </Tooltip>
  ) : (
    <Tooltip
      overlayInnerStyle={{
        height: '185px',
        width: '200px',
        borderRadius: '8px',
        backgroundColor: palette.white,
        padding: '8px',
        marginTop: '5px',
      }}
      arrowColor={palette.white}
      placement='bottomRight'
      trigger='click'
      title={renderSocials({ link, itemId, itemName, hotelListing })}
      getPopupContainer={(node) => node}
    >
      <ColCustomIcon>
        <CustomIcon
          fontSize={iconSize ? iconSize : 24}
          fill={palette.D400}
          icon={ShareIcon}
        />
      </ColCustomIcon>
    </Tooltip>
  );
};
